import { Injectable } from '@angular/core';
import * as moment from 'moment';
import 'rxjs/add/operator/map';

@Injectable({
    providedIn: 'root'
})
export class AppUtils {

    public static pollingFunctionUntilFuncConditionBecameTrue(
        funcToExec,
        funcCondition,
        timeout?
    ) {
        setTimeout(() => {
            if (!timeout) {
                timeout = 250;
            }
            const condition = funcCondition();
            if (!condition) {
                setTimeout(() => {
                    funcToExec();
                    AppUtils.pollingFunctionUntilFuncConditionBecameTrue(
                        funcToExec,
                        funcCondition,
                        timeout
                    );
                }, timeout);
            }
        }, 250);
    };

    generateUid() {
        let s4 = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        //return id of format 'aaaaaaaa'-'aaaa'-'aaaa'-'aaaa'-'aaaaaaaaaaaa'
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    public isDateLessOrEqual(customDate: Date, d: Date): boolean {
        const c = new Date(customDate.getFullYear(), customDate.getMonth(), customDate.getDate());
        const n = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        return c.getTime() <= n.getTime();
    }

    public agendaItemIsExpired(element): boolean {
        const nowDate = new Date();
        const toDate = new Date(element.toDate);
        return this.isExpired(nowDate, toDate);
    }

    public isExpired(d1, d2): boolean {
        let ret;
        if (d1 > d2) {
            ret = true;
        } else {
            ret = false;
        }
        return ret;
    }


    public formatDateDDMMYYYY(value) {
        let ret = null;
        if (value) {
            ret = new Date(value);
            ret = moment(ret).format('DD/MM/YYYY');
        }
        return ret;
    }

    public formatHourHHmm(value) {
        let ret = null;
        if (value) {
            const date = new Date(value);
            ret = moment(date).format('HH:mm');
        }
        return ret;
    }

    public retrieveValueOnPathForObject(object, path) {
        let ret = undefined;
        if (path && object) {
            ret = path.split('.').reduce((o, i) => o[i], object);
        }
        return ret;
    }

    public static buildUuid(prefix?: string) {
        let uuid = '';
        const separator = '-';
        const uuidFormalism = '#' + separator + '##';
        const uuidSubparts = uuidFormalism.split(separator);
        for (let i = 0; i < uuidSubparts.length; i++) {
            let currUuidSubpart = uuidSubparts[i];
            currUuidSubpart = currUuidSubpart.replace(/#/g, this.random());
            if (i === 0) {
                uuid = currUuidSubpart;
            } else {
                uuid = uuid + separator + currUuidSubpart;
            }
            // if (i !== uuidSubparts.length - 1) {
            //     uuid = uuid + separator;
            // }
        }
        if (prefix && prefix.length > 0) {
            prefix = prefix.trim();
            uuid = prefix + separator + uuid;
        }
        return uuid;
    }

    private static random() {
        return Math.floor((1 + Math.random() + new Date().getTime()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    public static removeMarkedContent(input: string, startMarker: string, endMarker: string): string {

        // Usa escapeRegExp per trattare startMarker e endMarker come stringhe letterali
        const start = AppUtils.escapeRegExp(startMarker);
        const end = AppUtils.escapeRegExp(endMarker);

        const regexString = `${start}.*?${end}`;

        const regex = new RegExp(regexString);
        return input.replace(regex, "");
    }

    public static removeMarkedContentPreservingEndMarker(input: string, startMarker: string, endMarker: string): string {

        // Usa escapeRegExp per trattare startMarker e endMarker come stringhe letterali
        const start = AppUtils.escapeRegExp(startMarker);
        const end = AppUtils.escapeRegExp(endMarker);

        const regexString = `${start}.*?(?=${end})`;

        const regex = new RegExp(regexString);
        return input.replace(regex, "");
    }

    // Funzione di escape per caratteri speciali nei pattern regex (simile a Pattern.quote in Java)
    public static escapeRegExp(text: string): string {
        return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    public static roundAndRenderToTwoDecimals(value: number): string {
        let val1 = AppUtils.roundToTwoDecimals(value);
        let val2 = AppUtils.renderAsTwoDecimals(val1);
        return val2;
    }

    //return 11.124 as 11.12, or 11.126 as 11.13, or 11.4 as 11.4 (as number)
    public static roundToTwoDecimals(value: number): number {
        const ret = (Math.round((value + Number.EPSILON) * 100) / 100);
        return ret;
    }

    // return the case 11.4 as 11.40 (as string!)
    public static renderAsTwoDecimals(value: number): string {
        const ret = value.toFixed(2);
        return ret;
    }

    public static buildDateFromTimeString(timeString: string): Date {
        const [hours, minutes] = timeString.split(':').map(Number);
        const now = new Date();
        return new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate(),
            hours,
            minutes
        );
    }
}
